import { unsubscribeToRowNotifications } from 'owa-mail-triage-notifications';
import { lazyRemoveTableFromStore } from 'owa-mail-triage-local-updates';

// Unsubscribe and remove all rows for this table from list view store
// Also remove the table from the store
export function onRemoveTable(tableViewId: string) {
    unsubscribeToRowNotifications(tableViewId);
    lazyRemoveTableFromStore.importAndExecute(tableViewId);
}
